export default "__VITE_ASSET__7e707efe__"